function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "phone_callback-24px");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Contact-Notes-&-History",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ADv2_ContactNotes_Recognised-Caller",
  transform: "translate(-1396.000000, -606.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  transform: "translate(821.000000, 589.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(572.698413, 15.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "phone_callback-24px"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 24.031746 0 24.031746 24 0 24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.026455,15.51 C18.7848148,15.51 17.5732143,15.31 16.4517328,14.94 C16.3516005,14.9 16.241455,14.89 16.1413228,14.89 C15.8809788,14.89 15.6306481,14.99 15.4303836,15.18 L13.2274735,17.38 C10.3937302,15.93 8.07066138,13.62 6.62875661,10.79 L8.83166667,8.59 C9.11203704,8.31 9.19214286,7.92 9.08199735,7.57 C8.71150794,6.45 8.51124339,5.25 8.51124339,4 C8.51124339,3.45 8.06064815,3 7.50992063,3 L4.00529101,3 C3.45456349,3 3.00396825,3.45 3.00396825,4 C3.00396825,13.39 10.6240344,21 20.026455,21 C20.5771825,21 21.0277778,20.55 21.0277778,20 L21.0277778,16.51 C21.0277778,15.96 20.5771825,15.51 20.026455,15.51 Z M5.03665344,5 L6.53863757,5 C6.60873016,5.89 6.75892857,6.76 6.99924603,7.59 L5.79765873,8.79 C5.3871164,7.59 5.12677249,6.32 5.03665344,5 L5.03665344,5 Z M19.0251323,18.97 C17.7033862,18.88 16.4317063,18.62 15.2201058,18.22 L16.4116799,17.03 C17.2628042,17.27 18.133955,17.42 19.015119,17.48 L19.015119,18.97 L19.0251323,18.97 Z M18.0238095,9 L15.4303836,9 L20.4570238,3.98 L19.0451587,2.57 L14.0185185,7.59 L14.0185185,5 L12.015873,5 L12.015873,11 L18.0238095,11 L18.0238095,9 Z",
  id: "Shape",
  fill: "#455A64",
  fillRule: "nonzero"
}))))));

var SvgInbound = function SvgInbound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInbound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inbound.0444c0dd.svg";
export { ForwardRef as ReactComponent };